import { Connection, NetworkNode } from 'src/common/interfaces/networks/diagrams';

export enum NetworkInstanceStatus {
  DEPLOYING = 'deploying',
  RUNNING = 'running',
  ERROR = 'error',
  DELETING = 'deleting',
  DELETED = 'deleted',
  PAUSED = 'paused',
}

export interface SubnetOutput {
  name: string;
  id: string;
  arn: string;
  urn: string;
  cidrBlock: string;
  availabilityZone: string;
  availabilityZoneId: string;
  vpcId: string;
  tags?: Record<string, string>;
}

export interface VpcOutput {
  id: string;
  arn: string;
  urn: string;
  cidrBlock: string;
  defaultNetworkAclId: string;
  defaultRouteTableId: string;
  defaultSecurityGroupId: string;
  tags?: Record<string, string>;
}

export interface SecurityGroupOutput {
  id: string;
  arn: string;
  urn: string;
  vpcId: string;
  name: string;
  ingress: unknown;
  egress: unknown;
  tags?: Record<string, string>;
}

export interface MachineOutput {
  id: string;
  arn: string;
  urn: string;
  amiId: string;
  instanceType: string;
  publicIp: string;
  privateIp: string;
  subnetId: string;
  vpcId: string;
  elasticIp?: string;
  tags?: Record<string, string>;
}

export interface NetworkInstanceOutput {
  vpc: VpcOutput;
  subnets: SubnetOutput[];
  machines: MachineOutput[];
  vpn: MachineOutput;
  securityGroups: SecurityGroupOutput[];
}

export interface NetworkEvent {
  _id: string;
  event: string;
  networkInstanceId: string;
  startTime: Date;
  endTime?: Date;
  summary?: string;
  log?: string;
  resources?: object;
  outputs?: NetworkInstanceOutput;
  error?: { message?: string };
  actor?: string;
  avatar?: string;
  username?: string;
}
export interface NetworkInstance {
  _id: string;
  status: NetworkInstanceStatus;
  resetsRequired: number;
  resetsRequested: number;
  templateId: string;
  private: boolean;
  startTime?: Date;
  pauseTime?: Date;
  users?: [];
  resources?: {
    type: string;
    outputs: {
      ami?: string;
      availabilityZone?: string;
      cidrBlock?: string;
      instanceType?: string;
      id: string;
      privateIp?: string;
      publicIp?: string;
      subnetId?: string;
      vpcSecurityGroupIds?: string[];
      tags: {
        Name: string;
      };
    };
  }[];
  networkDiagram: {
    nodes: NetworkNode[];
    connections: Connection[];
  };
  events?: NetworkEvent[];
}
